import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { AppService } from '../../app.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'request-success',
	standalone: true,
	imports: [MatButton, TranslateModule],
	templateUrl: './success.component.html',
	styleUrl: './success.component.scss'
})
export class SuccessComponent {
	public readonly appService = inject(AppService);
}
